import { Typography } from '@eventbrite/marmalade';
import React from 'react';
import styles from './PageTitle.module.scss';

interface PageTitleProps {
  pageTitle: string;
}

export const PageTitle: React.FunctionComponent<PageTitleProps> = ({ pageTitle }) => {
  return (
    <Typography variant="heading-md" className={styles.page_title}>
      {pageTitle}
    </Typography>
  );
};
